import { Injectable } from "@angular/core";
import { CanActivate, Router, UrlTree } from "@angular/router";
import { AuthService } from "../../../auth/data-access/auth.service";
import { ROLE_CODES } from "../../../auth/models/auth.model";

@Injectable({
  providedIn: 'root'
})

export class SuperAdminGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(): boolean | UrlTree {
    return this.authService.authUserComputedSignal()?.role.code === ROLE_CODES.SUPER_ADMIN
      ? true
      : this.router.createUrlTree(['/pages/empty']);
  }
}